module.exports = __webpack_public_path__ + "img/delete_col.7d1a8c44.svg";